module.exports = __webpack_public_path__ + "static/media/logo.e7de9cf5.png";